import { defineStore } from "pinia";

import cloneDeep from "lodash/cloneDeep";

import { useCodeStore } from "@/store/codeStore";
export const useArticleStore = defineStore({
  id: "useArticleStore", //ストアの識別子

  persist: true, //このストアの状態を永続化する

  //状態を定義
  state: () => ({
    codeStore: useCodeStore(),
    quills: [],
    articles: {
      article: Array.from({ length: 10 }, () => ({
        blockNo: 0,
        header: "",
        body1: "",
        articlehtml: "",
        image: null,
        explain: "",
        layout: "1",
        credit: "",
      })),
      kind: 1,
      title: "",
      category: "02",
      series: "",
      writer: "",
      raceDate: null,
      boatracePlace: null,
      raceNo: null,
      toFro: "",
      commentKind: "",
      notNews: "0",
      note: "",
      pr: 0,
      pagging: 0,
      newIcon: "",
      recordDate: "",
      fromDate: (() => {
        const d = new Date();
        d.setHours(22 + 9, 0, 0, 0);
        return d;
      })(),
      toDate: new Date(2099, 11, 32, 8, 59, 59),
      immediatelyOpen: 0,
      approval: 2,
      sponsered: "",
      articleId: 0,
      tag: "",
    },
    query: {},
  }),

  //状態を変更するためのアクション
  actions: {
    updateArticle(index, article) {
      this.articles.article[index] = cloneDeep(article);
    },

    setArticles(articles) {
      const currentArticleArray = cloneDeep(this.articles.article);
      this.articles = cloneDeep(articles);
      this.articles.article = cloneDeep(currentArticleArray);
    },

    setImage(index, image) {
      this.articles.article[index].image = image;
    },
    setQuills(value) {
      this.quills = value;
    },
    setQuery(newQuery) {
      this.query = newQuery;
    },
    reset() {},
  },

  //状態から派生した値を取得するためのゲッター
  getters: {
    getArticles() {
      return this.articles;
    },
    getArticle(index) {
      return this.articles[index];
    },
    getQuills() {
      return this.quills;
    },
  },
});
